import React, { useRef, useCallback, useEffect, useState, useMemo } from 'react';
import { Expandable } from 'react-virtualized-tree/lib/renderers';
import cloneDeep from 'lodash/cloneDeep';
import TreeNode from './tree/TreeNode';
import ExperimentNode from './tree/ExperimentNode';
import ScreenNode from './tree/ScreenNode';
import ProjectNode from './tree/ProjectNode';
import ProteinFormulationNode from './tree/ProteinFormulationNode';
import SeedNode from './tree/SeedNode';
import useBroadCast from 'business/broadcastLegacy';
import { TreeService } from 'business/services/TreeService';
import { getNewFolderType, getParents, isNullOrUndefined } from 'utils/Global';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { TreeControlProps } from 'business/models/CustomModels';

import { SeedFormulation } from './Seed/SeedFormulation';

const treeService: TreeService = new TreeService();
let crumbs = [];
function TreeControl(props: TreeControlProps) {
  const [nodes, setNodes] = useState([]);
  const loadedTreeNodes = [];
  const [expandedTreeNodeIds, setExpandedTreeNodesIds] = useState([]);
  const globalTreeNodes = [];
  const [openClickedState, setOpenClickedState] = useState(null);
  const expName = false;
  const [showSeedModal, setShowSeedModal] = useState(false);
  const [seedTreeNodeId, setSeedTreeNodeId] = useState(0);
  const broadcast = useBroadCast('globaldata');
  const broadcastRef = useRef(null);

  const [treeControlState, setTreeControlState] = useState({
    startTime: null,
    loadingDiv: <div id="loadingTree">Loading...</div>,
    treenodes: [],
    viewNodes: {},
    selectedNodeContainer: null,
    selectedNode: `node${props.gSelectedNode}`,
  });

  broadcastRef.current = broadcast;

  const generateAllTreeNodesById = useCallback(async (treeNodeId) => {
    let selectedNode = {};
    setTreeControlState({
      ...treeControlState,
      loadingDiv: <div id="loadingTree">Loading...</div>,
    });
    let nodes = [];
    let parentId = treeNodeId;
    let childNodes = await treeService.getTreeNodesService(treeNodeId);
    nodes = childNodes;

    while (parentId != -1) {
      const tempParentId = await treeService.getParentIdByTreeNodeId(parentId);
      childNodes = await treeService.getTreeNodesService(tempParentId);
      const parentNodeIndex = childNodes.findIndex((cn) => cn.id == parentId);

      if (parentNodeIndex !== -1) {
        childNodes[parentNodeIndex].children = nodes;
        childNodes[parentNodeIndex].state.expanded = true;
        nodes = childNodes;
      }
      if (parentId === treeNodeId) {
        selectedNode = childNodes[parentNodeIndex];
      }

      parentId = tempParentId;
    }

    treeControlState.treenodes = nodes;
    treeControlState.loadingDiv = null;
    treeControlState.selectedNode = `node${treeNodeId}`;

    setTreeControlState({ ...treeControlState });

    await onClickNodeChildren(selectedNode);
  }, []);

  const handleBroadcast = useCallback((e) => {
    if (
      !isNullOrUndefined(e.data.expId) &&
      !isNullOrUndefined(e.data.expName) &&
      globalTreeNodes.length > 0
    ) {
      const nodes = updateArrayForExp(globalTreeNodes, e.data, null);
      const state = treeControlState;
      state.treenodes = nodes;
      setTreeControlState({ ...state });
    }
  }, []);

  async function fetchData() {
    const state = treeControlState;
    let startTime = 0;
    let SelectedNode = state.selectedNode;
    crumbs = [];
    if (globalTreeNodes.length > 0) {
      state.loadingDiv = null;
      state.treenodes = globalTreeNodes;
      setTreeControlState({ ...state });
      return null;
    }
    startTime = new Date().getTime();
    let data = [];
    let root1;
    if (!isNullOrUndefined(props.commonTreeNodes) && props.commonTreeNodes.length > 0) {
      data = props.commonTreeNodes;
    } else if (props.dataSupplier) {
      const supplier = new props.dataSupplier();
      if (!isNullOrUndefined(props.experimentID) && props.experimentID > 0) {
        const parentNodes = await treeService.getDocumentParentNodes(
          props.experimentID,
          ETreeNodeTypes.Experiment,
        );
        const rootNode = parentNodes[parentNodes.length - 1];
        let children = [];
        let newParent;
        for (let i = parentNodes.length - 1; i >= 0; i--) {
          if (isNullOrUndefined(rootNode['children'])) {
            rootNode['children'] = await supplier.getTreeNodes(parentNodes[i].id);
            children = rootNode['children'];
            rootNode['state'] = { expanded: true };
          } else {
            newParent = children.find((c) => c.id === parentNodes[i].id);
            newParent.children = await supplier.getTreeNodes(parentNodes[i].id);
            children = newParent.children;
            newParent.state = { expanded: true };
          }
        }
        data = [rootNode];
        props.setCommonTreeNodes([rootNode]);
        SelectedNode = `node${newParent.id}`;
        props.setParentNode({ ...newParent });
      } else {
        root1 = await supplier.getTreeNodes();
        data = root1;
      }
    }

    state.loadingDiv = null;
    state.treenodes = data;
    state.startTime = startTime;
    state.selectedNode = SelectedNode;

    setTreeControlState({ ...state });
  }
  useEffect(() => {
    if (isNullOrUndefined(props.setTreeNodesRef)) {
      return;
    }
    props.setTreeNodesRef(treeControlState.treenodes);
  }, []);

  useEffect(() => {
    if (broadcast) {
      broadcast.onmessage = handleBroadcast;
    }
  }, [broadcast, handleBroadcast]);

  useEffect(() => {
    if (props.treeNodeIdToLoadTree && props.treeNodeIdToLoadTree !== -1) {
      generateAllTreeNodesById(props.treeNodeIdToLoadTree);
    } else {
      fetchData();
    }
  }, [expName, props.treeNodeIdToLoadTree]);

  useEffect(() => {
    if (
      props.openClicked != null &&
      props.openClicked !== 0 &&
      props.openClicked !== openClickedState
    ) {
      OpenClickHeader();
    }
    if (props.setParentSelectedNode) {
      props.setParentSelectedNode(treeControlState.selectedNodeContainer);
    }
    if (!isNullOrUndefined(treeControlState.selectedNodeContainer)) {
      const parents = getParents(nodes, treeControlState.selectedNodeContainer.id);
      if (isNullOrUndefined(parents)) {
        return;
      }
      const parentsWithChildrens = parents.filter((p) => !isNullOrUndefined(p.children));
      const state = treeControlState;
      state.viewNodes = parentsWithChildrens[0].children;
      setTreeControlState({ ...state });
    }
    setOpenClickedState(props.openClicked);
  }, [props.openClicked]);

  useEffect(() => {
    if (props.commonTreeNodes.length > 0 && props.isSetCommon) {
      const state = treeControlState;
      state.treenodes = props.commonTreeNodes;
      setTreeControlState({ ...state });
    }
  }, [props.commonTreeNodes]);

  async function onRefreshTreeNode(node) {
    const nodes = await updateChildren(node, treeControlState.treenodes);
    const curNode = getTreeNodeById(nodes, node.id);

    const state = treeControlState;
    state.viewNodes = curNode.children;
    state.treenodes = nodes;
    setTreeControlState({ ...state });
  }

  function getObjectByValue(object, value) {
    let result;
    if (!object || typeof object !== 'object') {
      return;
    }
    Object.values(object).some((v) => {
      if (v === value) {
        return (result = object);
      }
      return (result = getObjectByValue(v, value));
    });
    return result;
  }
  async function onRefreshTreeNodeAfterRename(node) {
    getObjectByValue(treeControlState.treenodes, node.id).name = node.newName;
    setTreeControlState({ ...treeControlState });
  }
  async function updateChildren(node, treeNodesCopy) {
    const supplier = new props.dataSupplier();
    const data = await supplier.getTreeNodes(node.id);
    const nodes = generateArrayForNewChildrens(
      treeControlState.treenodes,
      data,
      node.id,
      expandedTreeNodeIds.find((id) => id === node.id) ? true : null,
      false,
    );
    treeNodesCopy = [...nodes];
    if (!isNullOrUndefined(data) && data.length > 0) {
      await Promise.all(
        data.map(async (tn) => {
          const isFound = loadedTreeNodes.find((id) => id === tn.id);
          if (isFound) {
            await updateChildren(tn, treeNodesCopy);
          }
        }),
      );
    }
    return treeNodesCopy;
  }

  function OnClickSelect(node, _treeControlState = null) {
    const state = _treeControlState ? _treeControlState : treeControlState;
    const id = `node${node.id}`;
    const nodeId = node.id;
    if (!isNullOrUndefined(props.setParentNode)) {
      props.setParentNode(node);
    }

    const cNodes = getChildren(state.treenodes, nodeId);
    crumbs = getParents(state.treenodes, nodeId);

    if (cNodes !== undefined && cNodes !== null && cNodes.length > 0) {
      state.viewNodes = cNodes;
      state.selectedNode = id;
      setTreeControlState({ ...state });
    } else if (
      crumbs.length >= 2 &&
      node.type !== ETreeNodeTypes.Project &&
      node.type !== ETreeNodeTypes.ProjectFolder &&
      node.type !== ETreeNodeTypes.Projects &&
      node.type !== ETreeNodeTypes.ProjectsFolder &&
      node.type !== ETreeNodeTypes.ScreensFolder
    ) {
      state.viewNodes = crumbs[1].children;
      state.selectedNode = id;
      setTreeControlState({ ...state });
    }
  }

  function openNode(node) {
    if (props.disableOpen === true) {
      return;
    }
    const expId = isNullOrUndefined(node.extra) ? null : node.extra.id;
    if (node.type === ETreeNodeTypes.Seed) {
      OnClickSelect(node);
      setSeedTreeNodeId(node.id);
      setShowSeedModal(true);
      return;
    }
    if (props.onClickNode) {
      props.onClickNode(node);
    } else {
      const type = node.type === ETreeNodeTypes.Screen ? 'screen' : 'exp';
      if (
        treeControlState.selectedNode === `node${node.id}` &&
        (node.type === ETreeNodeTypes.Screen || node.type === ETreeNodeTypes.Experiment)
      ) {
        // saveDocumentToRecentlyOpenedList(node.id)
        window.open(`/${type}/${expId}`, `/${type}/${expId}`); //to open new page
      }
      if (
        treeControlState.selectedNode === `node${node.id}` &&
        node.type === ETreeNodeTypes.Protein
      ) {
        window.open(`/protein/${node.id}`, `/protein/${node.id}`); //to open new page
      }
    }
    OnClickSelect(node);
  }
  function getChildren(nodes, pTreeNodeId) {
    let array;
    for (let i = 0; i < nodes.length; i++) {
      let children = {};
      children = nodes[i].children;
      if (nodes[i].id === pTreeNodeId) {
        array = children;
        break;
      } else if (nodes[i].children) {
        array = getChildren(nodes[i].children, pTreeNodeId);
      }
    }
    return array;
  }

  function getTreeNodeById(nodes, pTreeNodeId) {
    let treeNode;
    for (let i = 0; i < nodes.length; i++) {
      let tempTreeNode = {};
      tempTreeNode = nodes[i];
      if (nodes[i].id === pTreeNodeId) {
        treeNode = tempTreeNode;
        break;
      } else if (nodes[i].children) {
        treeNode = getTreeNodeById(nodes[i].children, pTreeNodeId);
      }
    }
    return treeNode;
  }

  function generateArrayForNewChildrens(
    nodes,
    newChildren,
    pTreeNodeId,
    expanded,
    isUpdateViewNodes = true,
  ) {
    interface Node {
      children: React.ReactNode;
      state: any;
    }
    const array = [];
    for (let i = 0; i < nodes.length; i++) {
      let node: Node = {
        children: '',
        state: '',
      };
      node = nodes[i];
      if (nodes[i].children) {
        node.children = generateArrayForNewChildrens(
          nodes[i].children,
          newChildren,
          pTreeNodeId,
          expanded,
          isUpdateViewNodes,
        );
      }
      if (nodes[i].id === pTreeNodeId) {
        node.children = newChildren;
        node.state = { expanded };
        if (isUpdateViewNodes) {
          const state = treeControlState;
          state.viewNodes = node.children;
        }
      }
      array.push(node);
    }
    return array;
  }

  function updateArrayForExp(nodes, updatedExpNode, pNode) {
    const array = [];
    nodes.map((node) => {
      if (!isNullOrUndefined(node.extra) && node.extra.id == updatedExpNode.expId) {
        node.name = updatedExpNode.expName;
        const state = treeControlState;
        state.viewNodes = pNode.children;
        setTreeControlState({ ...state });
      }
      if (node.children) {
        node.children = updateArrayForExp(node.children, updatedExpNode, node);
      }
      array.push(node);
    });
    return array;
  }

  async function OnDoubleClick(node) {
    const state = treeControlState;
    let treeNodes = treeControlState.treenodes;
    const expanded =
      node.state !== null && node.state !== undefined && node.state.expanded
        ? node.state.expanded
        : false;
    const html = document.getElementsByTagName('html')[0];
    let data = [];
    html.style.cssText = '--cursor: wait';
    const { id } = node;
    if (id === undefined) {
      return;
    }

    if (expandedTreeNodeIds.find((tnIds) => tnIds === node.id)) {
      const filteredExpandedTreeNodeIds = expandedTreeNodeIds.filter(
        (tnIds) => tnIds !== node.id,
      );
      setExpandedTreeNodesIds(filteredExpandedTreeNodeIds);
    } else {
      setExpandedTreeNodesIds([...expandedTreeNodeIds, node.id]);
    }
    if (node.children && node.children.length > 0) {
      html.style.cssText = '--cursor: default';
      OnClickSelect(node);
      const nodes = generateArrayForNewChildrens(
        treeControlState.treenodes,
        node.children,
        id,
        !expanded,
      );
      treeNodes = nodes;
      return;
    }
    crumbs = getParents(treeNodes, id);
    for (let iter = 0; iter < loadedTreeNodes.length; iter++) {
      if (loadedTreeNodes[iter] === id) {
        html.style.cssText = '--cursor: default';
        return;
      }
    }
    loadedTreeNodes.push(id);

    if (props.dataSupplier) {
      const supplier = new props.dataSupplier();
      data = await supplier.getTreeNodes(id);
    }

    html.style.cssText = '--cursor: default';

    const onlyProjectsAndFolder = data.filter(
      (node) =>
        node.type == ETreeNodeTypes.Project ||
        node.type == ETreeNodeTypes.ProjectsFolder ||
        node.type == ETreeNodeTypes.ScreensFolder ||
        node.type == ETreeNodeTypes.ProjectFolder,
    );
    let deepCopyNodes = [];
    if (isNullOrUndefined(props.commonTreeNodes) || props.commonTreeNodes.length == 0) {
      deepCopyNodes = cloneDeep(treeNodes);
    } else {
      deepCopyNodes = cloneDeep(props.commonTreeNodes);
    }
    const filteredNewlyGenerateNodes = generateArrayForNewChildrens(
      deepCopyNodes,
      [...onlyProjectsAndFolder],
      id,
      !expanded,
    );
    const newlyGeneratedNodes = generateArrayForNewChildrens(
      treeNodes,
      data,
      id,
      !expanded,
    );
    setNodes(newlyGeneratedNodes);
    if (!isNullOrUndefined(props.setCommonTreeNodes)) {
      props.setCommonTreeNodes(filteredNewlyGenerateNodes);
    }
    OnClickSelect(node);
    treeNodes = newlyGeneratedNodes;
    if (props.setgSelectedNode) {
      if (
        node.type != ETreeNodeTypes.Experiment &&
        node.type != ETreeNodeTypes.Screen &&
        node.type != ETreeNodeTypes.Protein
      ) {
        props.setgSelectedNode(node);
      }
    }

    setTreeControlState({ ...state });
  }

  function onClickNodeChildren(selNode) {
    const state = treeControlState;
    state.selectedNodeContainer = selNode;

    setTreeControlState({ ...state });
    OnClickSelect(selNode, state);
    if (!isNullOrUndefined(props.setParentNode)) {
      if (
        selNode.type != ETreeNodeTypes.Experiment &&
        selNode.type != ETreeNodeTypes.Screen &&
        selNode.type != ETreeNodeTypes.Protein
      ) {
        props.setParentNode(selNode);
      }
    }
    if (props.setgSelectedNode) {
      if (
        selNode.type != ETreeNodeTypes.Experiment &&
        selNode.type != ETreeNodeTypes.Screen &&
        selNode.type != ETreeNodeTypes.Protein
      ) {
        props.setgSelectedNode(selNode);
      }
    }
    if (
      selNode.type === ETreeNodeTypes.Experiment ||
      selNode.type === ETreeNodeTypes.Screen ||
      selNode.type === ETreeNodeTypes.Project
    ) {
      if (props.setParentSelectedNode) {
        props.setParentSelectedNode(selNode);
      }
    } else {
      if (props.setParentSelectedNode) {
        props.setParentSelectedNode(undefined);
      }
    }
  }

  async function OpenClickHeader() {
    props.setParentSelectedNode(undefined);
    if (!isNullOrUndefined(treeControlState.selectedNodeContainer)) {
      if (
        treeControlState.selectedNodeContainer.type === ETreeNodeTypes.Experiment ||
        treeControlState.selectedNodeContainer.type === ETreeNodeTypes.Screen
      ) {
        const nodeType =
          treeControlState.selectedNodeContainer.type === ETreeNodeTypes.Experiment
            ? 'exp'
            : 'screen';
        window.open(
          `/${nodeType}/${treeControlState.selectedNodeContainer.extra.id}`,
          `/${nodeType}/${treeControlState.selectedNodeContainer.extra.id}`,
        );
      } else {
        OnDoubleClick(treeControlState.selectedNodeContainer);
      }
    }
  }

  async function newNode(newChildren, children, pTreeNodeId) {
    const node = getTreeNodeById(treeControlState.treenodes, pTreeNodeId);
    onRefreshTreeNode(node);
    return null;
  }

  const generateNode = useCallback((node, rest) => {
    if (node.type === ETreeNodeTypes.Experiment) {
      return (
        <ExperimentNode
          data={node}
          selectedNode={treeControlState.selectedNode}
          onClickHandler={OnClickSelect}
          openDocument={() => openNode(node)}
          rest={rest}
          onClickNodeChildren={onClickNodeChildren}
        />
      );
    }
    if (node.type === ETreeNodeTypes.Screen) {
      return (
        <ScreenNode
          data={node}
          selectedNode={treeControlState.selectedNode}
          onClickHandler={OnClickSelect}
          openDocument={() => openNode(node)}
          rest={rest}
          onClickNodeChildren={onClickNodeChildren}
        />
      );
    }
    if (node.type === ETreeNodeTypes.Protein) {
      return (
        <ProteinFormulationNode
          data={node}
          selectedNode={treeControlState.selectedNode}
          onClickHandler={OnClickSelect}
          rest={rest}
          key={node.id}
          openDocument={() => openNode(node)}
          onClickNodeChildren={onClickNodeChildren}
        />
      );
    }
    if (node.type === ETreeNodeTypes.Seed) {
      return (
        <SeedNode
          data={node}
          selectedNode={treeControlState.selectedNode}
          onClickHandler={OnClickSelect}
          rest={rest}
          key={node.id}
          openDocument={() => openNode(node)}
          onClickNodeChildren={onClickNodeChildren}
        />
      );
    }
    if (
      node.type === ETreeNodeTypes.Project ||
      node.type === ETreeNodeTypes.ProjectFolder ||
      node.type === ETreeNodeTypes.ProjectsFolder ||
      node.type === ETreeNodeTypes.Projects ||
      node.type === ETreeNodeTypes.Screens ||
      node.type === ETreeNodeTypes.ScreensFolder
    ) {
      return (
        <ProjectNode
          data={node}
          selectedNode={treeControlState.selectedNode}
          rest={rest}
          newFolderType={getNewFolderType(treeControlState.treenodes, node)}
          newNode={newNode}
          onClickHandler={OnClickSelect}
          openDocument={() => OnDoubleClick(node)}
          onContextMenuClick={() => {}}
          onClickNodeChildren={onClickNodeChildren}
          onRefreshTreeNode={onRefreshTreeNode}
          isShowContext={props.isShowContext}
        />
      );
    }

    return (
      <Expandable node={node} {...rest}>
        <TreeNode
          data={node}
          selectedNode={treeControlState.selectedNode}
          onClickHandler={OnClickSelect}
          openDocument={() => OnDoubleClick(node)}
          onClickNodeChildren={onClickNodeChildren}
        />
      </Expandable>
    );
  }, []);
  function handleChange(nodes) {
    const state = treeControlState;
    state.treenodes = nodes;
    setTreeControlState({ ...state });
  }

  const renderChild = useMemo(() => {
    return props.render
      ? props.render(
          treeControlState.treenodes,
          treeControlState.viewNodes,
          newNode,
          onClickNodeChildren,
          OnDoubleClick,
          generateNode,
          handleChange,
          treeControlState.loadingDiv,
          crumbs,
          treeControlState.selectedNodeContainer,
          onRefreshTreeNode,
          onRefreshTreeNodeAfterRename,
        )
      : //this is not being used. we shold remove this.
        null;
  }, [
    treeControlState.viewNodes,
    treeControlState.treenodes,
    treeControlState.selectedNodeContainer,
  ]);

  return (
    <>
      {renderChild}
      <SeedFormulation
        treeNodeId={seedTreeNodeId}
        show={showSeedModal}
        setShow={setShowSeedModal}
        isNew={false}
      />
    </>
  );
}
export default TreeControl;
